module.exports = __webpack_public_path__ + "img/plant_2_small.01e96fcb.webp";